import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"
import "./assets/fonts/unison-pro/unison-pro.css";
import "./assets/fonts/robo/robo.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import store from "./store";
import "react-toastify/dist/ReactToastify.css";
import { SocketProvider } from "./components/socket/SocketProvider";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { installMediaCaptureHook } from "./util/mediaTrackRegistry";

installMediaCaptureHook();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "989249631540-qp40u9k53pno4di930mroddiqat374pm.apps.googleusercontent.com"}>
    <Provider store={store}>
      <SocketProvider>
        <App />
      </SocketProvider>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
    </Provider>
  </GoogleOAuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
